import firebase from 'firebase/app'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAx1lYygTm-2_knu2KNiUjt6WMpdlEBePI",
    authDomain: "eng4excise-dev.firebaseapp.com",
    projectId: "eng4excise-dev"
};

firebase.initializeApp(config);